import {ISize} from "./Geom";

export const Scalable = {
    get scaleX(this: PIXI.Container) {
        return this.scale.x;
    },
    set scaleX(value: number) {
        this.scale.x = value;
    },
    get scaleY(this: PIXI.Container) {
        return this.scale.y;
    },
    set scaleY(value: number) {
        this.scale.y = value;
    },
    get scaleXY(this: PIXI.Container) {
        return this.scale.x;
    },
    set scaleXY(value: number) {
        this.scale.set(value);
    },
    get skewX(this: PIXI.Container) {
        return this.skew.x;
    },
    set skewX(value: number) {
        this.skew.x = value;
    },
    get skewY(this: PIXI.Container) {
        return this.skew.y;
    },
    set skewY(value: number) {
        this.skew.y = value;
    },
    setBounds(this: PIXI.Container, width: number | ISize, height?: number | "cover" | "stretch" | "fit", scaleMode?: "cover" | "stretch" | "fit"): void {
        if (typeof width !== "number") {
            scaleMode = height as "cover" | "stretch" | "fit";
            height = width.height;
            width = width.width;
        } else {
            height = height as number;
        }
        if (scaleMode === "stretch") {
            this.width = width;
            this.height = height;
        } else {
            this.scale.set(1);
            const s = scaleMode === "cover" ?
                Math.max(width / this.width, height / this.height) :
                Math.min(width / this.width, height / this.height);
            this.width *= s;
            this.height *= s;
        }
    },
};
